import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon60: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#404040"
        d="M7.996 0C6.896 0 6 .952 6 2.121l-3.065.004C1.316 2.125 0 3.523 0 5.243v7.507C0 15.093 1.793 17 4 17h12c2.207 0 4-1.907 4-4.25V5.243c0-1.72-1.317-3.118-2.936-3.118H14v-.004C14 .952 13.104 0 12.003 0H7.996ZM1 12.75V5.243c0-1.134.868-2.056 1.934-2.056H6.5c.277 0 .5-.237.5-.531v-.535c0-.584.448-1.059.997-1.059h4.007c.55 0 .997.475.997 1.059v.535c0 .294.223.531.5.531h3.564c1.067 0 1.936.922 1.936 2.056v7.507c0 1.757-1.347 3.187-3 3.187H4c-1.655 0-3-1.43-3-3.187Zm13.5-7.438c-.277 0-.5.237-.5.532 0 .294.223.53.5.53H16.5c.277 0 .5-.236.5-.53 0-.295-.223-.532-.5-.532H14.5ZM6 9.562c0 2.344 1.793 4.25 4 4.25 2.205 0 4-1.906 4-4.25 0-2.343-1.795-4.25-4-4.25-2.207 0-4 1.907-4 4.25Zm1 0c0-1.757 1.346-3.188 3-3.188s3 1.431 3 3.188c0 1.758-1.346 3.188-3 3.188s-3-1.43-3-3.188Z"
      />
    </Svg>
  )
}
